<template>
    <div>
        <h1 class="font-active mb-3">Pre-Designed  {{ metal.values.product_name }}</h1>
        <div class="price_box my-4 pb-md-3">
            <div class="price_igi price_box">
                <h2 class="">
                {{$formatPrice(price)}}
                <span class="ms-2" v-if="!$country.is_india && metal.values.discount_label">{{ $formatPrice(mrp) }}</span>
                <!-- <div v-if="!$country.is_india" class="d-none d-xxl-block disc_chip_pdp">{{ metal.values.discount_label }}% OFF</div>
                <p v-if="!$country.is_india" class="d-none d-xxl-block lowest_price_pdp">Lowest Price Ever</p> -->
                </h2>
                <div class="igi_block">
                    <img width="30" height="30" src="https://assets.friendlydiamonds.com/fdl/fd_gif/diamond.gif" alt="igidiamond">
                    <span>IGI Certified</span>
                </div>
            </div>
            <div class="d-flex mt-2 w-100" v-if="!$country.is_india">
                <div v-if="metal.values.discount_label" class="disc_chip_pdp">{{ metal.values.discount_label }}% OFF</div>
                <p v-if="metal.values.lowest_price_label && metal.values.discount_label" class="lowest_price_pdp">Lowest Price Ever</p>
            </div> 
            <div class="affirm_info" v-if="$country.affirm">
                <p class="affirm-as-low-as mb-0 mt-2" data-page-type="setting" :data-amount="price * 100"></p>
            </div>
        </div>   
                
                
        <div class="row">
            <div class="col-md-12 mb-4 slide ">
                    <PresetDetailPresetDropdownSlide @toggleOption="toggleOption" :type="'metal'" :label="'metal'" :option="options.metals"/>
            </div>
            <div class="col-md-12 mb-4 slide ">
                <PresetDetailPresetDropdownSlide @toggleOption="toggleOption" :type="'shape'"  :label="'Diamond shape'" :option="options.shape"/>
            </div>
            <div class="col-md-12 mb-4 slide ">
                <PresetDetailPresetDropdownSlide @toggleOption="toggleOption" :type="'weight'"  :label="'Diamond carat'" :option="options.weight"/>
            </div>
            <div class="col-md-12 col-lg-6 mb-4 drop_down dd_first ">
                <PresetDetailPresetDropDown  @toggleOption="toggleOption" :type="'cen_stone_quality'" :label="'diamond quality'" :option="options.cen_stone_quality" />
            </div>
            <div class="col-md-12 col-lg-6 mb-4 drop_down ">
                <PresetDetailPresetDropDown 
                    ref="viewerror"
                    @toggleOption="toggleOption" 
                    :type="'size'" 
                    :label="'ring size'"
                    :option="options.size" 
                    :validation="errorMsgs && errorMsgs.size"
                />
                <div v-if="errorMsgs.size" class="error-msg"> {{ errorMsgs.size.join(" ") }} </div>
            </div>

            <div class="col-md-12 mb-4 select_block_mod" ref="viewerror">
                <div class="inscription">
                    <label>Add An Inscription</label>
                    <ModalPresetInscription />
                </div>
                <input maxlength="15" name="inscription" v-model="formData.inscription" :class="{ 'validation' : errorMsgs.inscription}" placeholder="Max 15 characters" type="text">
                <div v-if="errorMsgs.inscription" class="error-msg">{{ errorMsgs.inscription.join(" ") }}</div>
            </div>

            <div class="col-md-12 mb-4 ">
                <div v-if="$country.appraisal">
                    <div class="check_band ">
                        <div class="checkbox_custom ms-0" id="appraisal">
                            <div class="checkbox_custom_labels" @click="toggleAppraisal()">
                                <span :class="{ 'checked' : formData.has_appraisal,  'unchecked' : !formData.has_appraisal }"></span>
                                <label class="mb-0">Add an Appraisal Certificate (+ {{ $formatPrice(50)}}) </label>
                            </div>
                            <div class="tooltip_box">
                                <SvgHeaderSvg class="ms-1" :type="'info'" />
                                <div class="tooltip_text tooltip_text_mod">This document is usually required to apply for your {{ $t('jewelry') }} insurance after you recieve the item</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
            <div class="col-md-12 ">
                <div>
                    <div class="ship_date my-md-4">
                        <CommonEstimateDate :module_subtype="'preset'" :setting_id="metal.id" :diamond_id="''" />
                    </div>
                </div>
                <div class="select_btn_block">
                    <div class="alert alert-info mb-0" role="alert" v-if="settingComponent.availability === 0">
                        *This item is no longer available
                    </div>
                    <div class="select_button" v-if="buttonLoader">
                        <span>PLEASE WAIT...</span>
                    </div>
                    <div v-else-if="settingComponent.availability === 1" @click="addToCart()" class="select_button">
                        <div>add to bag</div>
                    </div>
                </div>
            </div>
            <div class="my-4 py-2 col-md-12">
                <CommonOrderInclude />
            </div>
            <div class="col-lg-6 col-md-12 mb-3" >
                <ModalDropHint :data="{ id: sn}" class="mt-2"/>
            </div>
            <div class="col-lg-6 col-md-12 mb-3">
                <ModalGemologist :data="{ id: sn}" class="mt-2"/>
            </div>
            <div class="col-12 mb-3">
                <CommonFreeCartOffer v-if="$country.free_product" class="mt-2" />
            </div>    

            <div class="col-12 col-md-12 col-lg-12  mb-4" v-if="settingComponent.bands.length != 0">
                <div class="match_band_drop">
                    <CyoBandMatchingBandList :item="settingComponent" :sub_type="'preset'"/>
                </div>
            </div>
        </div>
            
        
    </div>
</template>

<script setup>

    import { cartStore } from '@/stores/cart/cart';
    const storeCart = cartStore()
    const viewerror = ref(null);
    const { $formatPrice } = useNuxtApp()
    const { $country } = useNuxtApp();
    const { $toast, $presetDetailGtag, $presetToCartGtag } = useNuxtApp()
    const localePath = useLocalePath();
    
    const props = defineProps({
        options:Object,
        activeDiamondVariation:Object,
        item:Object,
        settingComponent: Object,
        sn: String
        
    })
 
    const emit = defineEmits(['toggleOption'])

    const formData = reactive ({
        has_appraisal: false,
        inscription: ''
    })

    const buttonLoader = ref(false)

    const errorMsgs = ref({})


    const metal = computed (() => {
        return props.options.metals.find(item => item.selected === 1)
    })

    // console.log(metal,'abc');

    const price = computed(()=>{
        const item = metal ? metal.value.values.price + props.activeDiamondVariation.price : 0 
        if( import.meta.client && item !== null && window.affirm !== undefined ){
            nextTick(() => {
                window.affirm.ui.ready(() => {
                    window.affirm.ui.refresh();
                });
            });
        }
        return item
    })
    const scrollToError = async () => {
        await nextTick();
        if (viewerror.value) {
            const dropdownEl = viewerror.value.$el || viewerror.value;
            dropdownEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };
    const mrp = computed(() => {
        return metal ? metal.value.values.mrp + props.activeDiamondVariation.mrp : 0 
    })

    const currentSize = computed(() => {
        const size = props.options.size.find((item => item.selected === 1))
        // console.log(size.value,'currentttttt')
        if(!size) {
            return null
        }
        return size.value
    })

    const toggleOption = (type) => {
        emit('toggleOption', type)
    }

    const toggleAppraisal = () => {
        formData.has_appraisal = !formData.has_appraisal
    }

    const addToCart = async () => {
        buttonLoader.value = true

        errorMsgs.value = {}

        if(!currentSize.value) {
            errorMsgs.value.size = ["Please Select Ring Size."]
            await scrollToError(); 
            buttonLoader.value = false;
            return
        }

        formData.has_appraisal = formData.has_appraisal ? 1 : 0

        const form_Data = {...formData, setting_id: metal.value.id, preset_diamond_id: props.activeDiamondVariation.id, size: currentSize.value }

        // console.log(form_Data,currentSize.value,'formdataaaaaa');


        try {
            const response = await $fetch (useCountryPath('/setting/preset/add/session') , {
                method : 'POST',
                body: form_Data
            })

            if(response) {
                buttonLoader.value = false
                $presetToCartGtag({ 
                    id: metal.value.id, product_name: metal.value.values.product_name, sub_type: 'preset', price: price.value 
                })
                $toast('success', 'Congratulations!', 'Item added to cart.');
                // $store.dispatch('getCartCount');
                setTimeout(() => {
                    window.location.href = localePath( {path: '/cart'});
                }, 500);
            }

        } catch (err) {
            buttonLoader.value = false
            if (err.status === 422) {
                errorMsgs.value = err.data.errors
                scrollToError(); 
            }
                
            

        }
    }

    onMounted( async () => {
        await $presetDetailGtag({ id: metal.value.id, product_name: metal.value.values.product_name, sub_type: 'preset', price: price.value })
    })


</script>

<style scoped>
    
    .select_block_mod input.validation{
        border: 1px solid #ff0000;
    }
    .select_block_mod input {
        font-size: 16px !important;
    }
    .error-msg{
        color:  #ff0000;
        font-size: 14px;
        line-height: 1.3;
        margin-top: 5px;
    }
    
    .igi_block span {
        font-size: 12px;
        color: #606060;
        font-weight: 600;
    }

    .igi_block {
        background: #f5f5f5;
        display: flex;
        align-items: center;
        padding: 0 13px 0 8px;
        border-radius: 5px;
    }
    .price_igi {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .cut_price {
            color: #9a9999;
            font-size: 18px;
            text-decoration: line-through;
        }
    h1{
        font-size: 32px;
        color: #212529;
        text-transform: capitalize;
    }
    
    .price_box h2 {
    font-size: 24px;
        color: #212529;
        margin: 0;
        line-height: 1.2;
        font-weight: 600;
        display: flex;
        align-items: center;
    }
    .price_box h2 span {
        color: #909090;
        font-weight: 400;
        font-size: 18px;
        text-decoration: line-through;
    }

    h2{
        font-size: 24px;
        color: #212529;
        margin: 0;
        font-weight: 600;
    }
    .ship_date p {
        font-size: 14px;
        color: #212529;
        font-weight: 400;
    }
    .ship_date p span {
        color: var(--green);
        font-weight: 600;
    }
    .inscription {
        display: flex;
    }

   
    label {
        /* display: block; */
        color: #353535;
        font-size: 14px;
        font-weight: 600;
    }

    input {
        border: 1px solid #ced4da;
        padding: 0 16px;
        font-size: 14px;
        cursor: pointer;
        height: 44px;
        width: 100%;
        outline: none;
        border-radius: 4px;
        margin: 2% 0 0;
    }

    /* .checkbox_custom .svg-head {
        height: 22px;
    }
    .checkbox_custom {
        display: flex;
        align-items: center;
        margin-left: 15px;
        width: fit-content;
    }
    .checkbox_custom_labels{
        display: flex;
        align-items: center;
    }
    .checkbox_custom span {
        cursor: pointer;
        margin-right: 6px;
        height: 20px;
        width: 20px;
        border-radius: 2px;
        position: relative;
        display: inline-block;
    } */
    .select_button {
        background: var(--green);
        color: #fff;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        text-transform: uppercase;
        letter-spacing: 2px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
    }
    /* .checkbox_custom .unchecked {
        border: 1px solid #ccc;
    }

    .checkbox_custom .checked {
        border: 1px solid var(--green);
        background: var(--green);
    }

    .checkbox_custom .checked:before {
        position: absolute;
        content: "";
        height: 5px;
        width: 9px;
        border-left: 2px solid #fff;
        border-bottom: 2px solid #fff;
        transform: rotate(-45deg);
        top: 5px;
        left: 4px;
    } */

    .tooltip_box {
        position: relative;
    }
    
    .tooltip_box .tooltip_text {
        visibility: hidden;
        width: 120px;
        background-color: rgb(56, 55, 55);
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 10px;
        position: absolute;
        z-index: 1;
        bottom: 100%;
        left: 50%;
        margin-left: -60px;
        font-size: 14px;
        line-height: normal;
    }
    
    .tooltip_box:hover .tooltip_text {
        visibility: visible;
    }
    .tooltip_text span{
        text-transform: capitalize;
    }
    .tooltip_text_mod{
        min-width: 200px;
        left: -100% !important;
    }
    @media(min-width: 992px) and (max-width: 1100px){
        .modify_column{
            max-width: 100%;
        }
    }
    @media(max-width: 992px){
        h1{
            font-size: 24px;
        }
        h2{
            font-size: 22px;
        }
        .tooltip_text.tooltip_text_mod {
            margin-left: -150px;
        }
    }
    @media(max-width: 767px){
        .price_igi {
            width: 100%;
        }
        h1{
            margin-top: 30px;
        }
        h2{
            font-size: 20px;
        }
        .tooltip_text.tooltip_text_mod {
            margin-left: -120px;
        }
        .inscription label {
            font-size: 14px;
        }
        /* .checkbox_custom_labels label {
            font-size: 16px;
        }

        .checkbox_custom span {
            height: 16px;
            width: 16px;
        } */

        .cut_price {
            font-size: 16px;
        }

        /* .checkbox_custom .checked:before {
            top: 4px;
            left: 3px;
        } */
        .select_btn_block {
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.15);
            padding: 13px;
            border-radius: 8px 8px 0 0;
            background: #fff;
            z-index: 9;
        }
        
        .slide {
            margin-bottom: 0 !important;
        }
        .drop_down {
            margin-bottom: 20px !important;
        }
        .dd_first {
            margin-top: 20px;
        }
        .inscription {
            margin-bottom: 4px !important;
        }
    }
</style>